module.exports = __webpack_public_path__ + "img/sits_01.dfcbf539.png";